import { render, staticRenderFns } from "./IPBanDialog.vue?vue&type=template&id=4ef3cd48&"
import script from "./IPBanDialog.vue?vue&type=script&lang=ts&"
export * from "./IPBanDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports